import Masker from 'string-mask';

import { isNaN } from 'lodash';
import maskString from './mask';

const formaters = {
  documentOrEmail: () => {
    const cpfMask = new Masker('000.000.000-00');
    const cnpjMask = new Masker('00.000.000/0000-00');
    return (value) => {
      let newValue = value.replace(/[^0-9]+/g, '');

      const oldValue = [12, 15].some((i) => i === newValue.length) ? newValue.substr(0, value.length - 1) : newValue;

      if(!value.match(/[a-zA-Z@]+/g) || cpfMask.validate(oldValue) || cnpjMask.validate(oldValue)) {

          if(newValue.length <= 11) {
            newValue = cpfMask.apply(newValue);
          } else {
            newValue = cnpjMask.apply(newValue.substr(0, 14));
          }

          if(isNaN(parseInt(newValue[newValue.length - 1]))) {
            newValue = newValue.substr(0, newValue.length - 1);
          }

          return newValue;
      }
    }
  },
  document: () => {
    const cpfMask = new Masker('000.000.000-00');
    const cnpjMask = new Masker('00.000.000/0000-00');

    return (value) => {
      let newValue = value.replace(/[^0-9]+/g, '');

      if(newValue.length <= 11) {
        newValue = cpfMask.apply(newValue);
      } else {
        newValue = cnpjMask.apply(newValue.substr(0, 14));
      }

      if(isNaN(parseInt(newValue[newValue.length - 1]))) {
        newValue = newValue.substr(0, newValue.length - 1);
      }

      return newValue;
    }
  },
  _default: (mask = null) => (value) => {
    if (!mask) {
      return value;
    }
    return maskString(value, mask, { D: /[0-9]/ });
  },
  numbers: () => {
    return (value) => {
      if (value) {
      let newValue = value.toString().replace(/[^0-9]+/g, '');
      if(isNaN(parseInt(newValue[newValue.length - 1]))) {
        newValue = newValue.substr(0, newValue.length - 1);
      }
      return newValue;
    } else {
      return value;
    }
    }
  },
  lettersAndSpace: () => {
    return (value) => {
      if (!value) return;
      const stringValue = value.toString();
      if (stringValue.match(/^[a-zA-Z\s]*$/)) {
        return stringValue
      } else {
        return stringValue.substr(0, stringValue.length - 1);
      }
    }
  }
};

export default formaters;
